<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div
            class="app-l-page__previous"
            (click)="navigateToListingPage()"
            (keypress)="navigateToListingPage()">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a
                        (click)="navigateToListingPage()"
                        (keypress)="navigateToListingPage()"
                        >Series</a
                    >
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <form novalidate [formGroup]="courseEditForm">
            <div id="resource-section" class="form-wrapper-80" *ngIf="isLoaded">
                <div class="lang-Btn">
                    <a
                        tabindex="0"
                        class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                        (click)="showFrench = !showFrench"
                        (keypress)="showFrench = !showFrench"
                        [class.active]="showFrench"
                        >French</a
                    >
                    <a
                        tabindex="0"
                        class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                        (click)="showSpanish = !showSpanish"
                        (keypress)="showSpanish = !showSpanish"
                        [class.active]="showSpanish"
                        >Spanish</a
                    >
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label">Title (English)</label>
                    <input
                        class="app-c-form-control"
                        formControlName="titleen"
                        required
                        type="text" />
                    <div
                        class="error-message"
                        *ngIf="f.titleen.touched && f.titleen.errors?.required">
                        The Title (English) is required
                    </div>
                </div>
                <div class="app-c-form-group" *ngIf="showFrench">
                    <label class="app-c-form--label">Title (French)</label>
                    <input
                        class="app-c-form-control"
                        formControlName="titlefr"
                        type="text" />
                </div>
                <div class="app-c-form-group" *ngIf="showSpanish">
                    <label class="app-c-form--label">Title (Spanish)</label>
                    <input
                        class="app-c-form-control"
                        formControlName="titlees"
                        type="text" />
                </div>

                <div class="app-c-form-group">
                    <label class="app-c-form--label">Author (English)</label>
                    <input
                        class="app-c-form-control"
                        required
                        type="text"
                        formControlName="authoren" />
                    <div
                        class="error-message"
                        *ngIf="
                            f.authoren.touched && f.authoren.errors?.required
                        ">
                        The Author (English) is required
                    </div>
                </div>
                <div class="app-c-form-group" *ngIf="showFrench">
                    <label class="app-c-form--label">Author (French)</label>
                    <input
                        class="app-c-form-control"
                        formControlName="authorfr"
                        type="text" />
                </div>
                <div class="app-c-form-group" *ngIf="showSpanish">
                    <label class="app-c-form--label">Author (Spanish)</label>
                    <input
                        class="app-c-form-control"
                        formControlName="authores"
                        type="text" />
                </div>
                <div
                    class="app-c-form-group desctext-box"
                    *ngIf="seriesPageType != 'customType'">
                    <label class="app-c-form--label" for="category" translate>Category</label>
                    <select
                        class="app-c-form-control"
                        id="category"
                        formControlName="category"
                        required>
                        <option
                            *ngFor="let category of categoryList"
                            [ngValue]="category.ID">
                            {{ category.Title }}
                        </option>
                    </select>
                    <div
                        class="error-message"
                        *ngIf="
                            f.category.touched && f.category.errors?.required
                        ">
                        The Category is required
                    </div>
                </div>

                <div
                    class="icon-input org-select"
                    *ngIf="seriesPageType == 'customType'">
                    <div>
                        <multiselect-autocomplete
                            placeholder="Select an organization"
                            [items]="multiSelOrgs"
                            formControlName="orgIds"
                            [formValue]="courseEditForm.value.orgIds"
                            (onSelectItems)="
                                onSelectOrgs($event)
                            "></multiselect-autocomplete>
                        <div class="error-message" *ngIf="orgError !== ''">
                            {{ orgError }}
                        </div>
                        <div class="error-message"
                            *ngIf="
                                orgError === '' &&
                                f.organizationID.touched &&
                                f.organizationID.errors?.required
                            ">
                            Please select an organization
                        </div>
                    </div>
                </div>

                <div class="icon-input image-box">
                    <label class="app-c-form--label"
                        >Background Image
                        <span class="info-title"
                            >(Max: 2MB | Format: JPG/JPEG)</span
                        ></label
                    >
                    <input
                        type="file"
                        (change)="courseImageUpload($event)"
                        #input />
                </div>
                <div
                    class="preview image-preview"
                    *ngIf="courseEditForm.value.imageUrl">
                    <p>Image preview</p>
                    <img [src]="courseEditForm.value.imageUrl" />
                </div>

                <div class="image-box">
                    <div class="attachments">
                        <div class="attachment">
                            <div class="icon-input">
                                <label for="audioFileUpload"
                                    >Audio File
                                    <span class="info-title"
                                        >(Max: 25MB | Format: MP3)</span
                                    ></label
                                >
                                <input
                                    placeholder="File Attachment"
                                    type="file"
                                    required
                                    (change)="
                                        changeAudioUploadListener($event)
                                    " />
                            </div>
                            <p class="red" *ngIf="audioerror">{{ errors }}</p>
                            <div
                                class="preview audio-preview"
                                *ngIf="courseEditForm.value.audioUrl">
                                <label class="app-c-form--label"
                                    >Audio preview</label
                                >
                                <wt-audio
                                    [mediaUrl]="courseEditForm.value.audioUrl">
                                </wt-audio>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="icon-input">
                    <label class="app-c-form--label"
                        >Transcript (English)<span>*</span></label
                    >
                    <ckeditor
                        [editor]="Editor"
                        formControlName="transcripten"
                        [config]="config"
                        id="courseDescription"
                        (change)="validateEditor()">
                    </ckeditor>
                    <div
                        class="error-message"
                        *ngIf="
                            f.transcripten.touched &&
                            f.transcripten.errors?.required
                        ">
                        The Transcript (English) is required
                    </div>
                </div>
                <div class="icon-input desctext-box" *ngIf="showFrench">
                    <label class="app-c-form--label">Transcript (French)</label>
                    <ckeditor
                        [editor]="Editor"
                        formControlName="transcriptfr"
                        [config]="config"
                        id="courseDescriptionFr">
                    </ckeditor>
                </div>
                <div class="icon-input desctext-box" *ngIf="showSpanish">
                    <label class="app-c-form--label"
                        >Transcript (Spanish)</label
                    >
                    <ckeditor
                        [editor]="Editor"
                        formControlName="transcriptes"
                        [config]="config"
                        id="courseDescriptionEs">
                    </ckeditor>
                </div>

                <div class="icon-input desclang-box">
                    <label class="toggle-switch">
                        <input type="checkbox" formControlName="active" />
                        <span class="toggle-slider"></span>
                    </label>
                    <span class="toggle-label">Active?</span>
                </div>
                <div class="fixed-footer">
                    <p
                        class="red"
                        *ngIf="
                            submitButtonPressed &&
                            !courseEditForm.valid &&
                            errors === ''
                        ">
                        Please check the errors
                    </p>
                    <p class="red">{{ errors }}</p>
                    <button
                        type="button"
                        class="app-c-btn app-c-btn--primary app-c-btn--curve"
                        (click)="doSave()">
                        Save
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
